import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Super Teacher";

// Lesson, course and catalog pages arrive with their own title and head tags, rendered by the
// server for crawlers (server/webapp_seo/). The app never sets any itself, so once the visitor
// navigates away from the page they landed on, this restores the static title and drops the
// server's tags, which would otherwise describe a page that is no longer shown.
//
// Compares pathnames rather than listening to history: the app replaces history at boot without
// leaving the page.
export const useResetServerRenderedHead = () => {
  const { pathname } = useLocation();
  const landingPathname = useRef<string | null>(pathname);

  useEffect(() => {
    if (
      landingPathname.current === null ||
      landingPathname.current === pathname
    ) {
      return;
    }
    landingPathname.current = null;
    document.title = DEFAULT_TITLE;
    document
      .querySelectorAll("[data-webapp-seo]")
      .forEach((node) => node.remove());
  }, [pathname]);
};
